import { Settings } from 'vrlcm-gui-types';

export const settings: Settings = {
  fetching: false,
  groups: []
};
